import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface IprovinceUnit {
  title: string
  code: number
}

export interface IProvince {
  id: number
  code: string
  title: string
  delf: number
  unitId: number
  unitTitle: string
  regionId: number
  regionTitle: string
  nationwideId: number
  nationwideTitle: string
  view: number
}
export interface IProvinceEdit {
  unitId: number
  unitTitle: string
  listData: listData[]
}
export interface listData {
  id: number
  code: string
  title: string
  parentId: number
}

export interface IProvinceFilter {
  listUnit?: number[];
  search?: string;
}





// new 
export interface ISLProvince {
  id: number
  code: string
  title: string
  view: number
  parentId: any
  level: number
  children: Children[]
}

export interface Children {
  id: number
  code: string
  title: string
  view: number
  parentId: number
  level: number
  children: Children2[]
}

export interface Children2 {
  id: number
  code: string
  title: string
  view: number
  parentId: number
  level: number
  children: Children3[]
}

export interface Children3 {
  id: number
  code: string
  title: string
  view: number
  parentId: number
  level: number
  children: any[]
}

// end new





// danh sách tỉnh thành
export const gListIProvinceUnit = async (limit?: number, pageNumber?: number, search?: string, listUnit?: number[]) => {
  const path = "provinceUnit/listProvinceUnit"
  const params = {
    limit, pageNumber, search, listUnit
  }
  const result: ResponseSuccessTotal<IProvince[]> = await axiosClient.get(
    path, { params }
  )
  return result
};

// danh sách toàn quốc bao gồm vùng miền, đơn vị, tỉnh thành
// provinceUnit/listNationwide
export const gListNationwide = async () => {
  const path = "provinceUnit/listNationwide"
  const result: ResponseSuccessTotal<ISLProvince[]> = await axiosClient.get(
    path, {}
  )
  return result
};

// thông tin tỉnh thành
export const gInfoProvince = async (id: number) => {
  const path = "provinceUnit/infoProvinceUnit"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IProvinceEdit> = await axiosClient.get(
    path, { params }
  )
  return result
}

export const addIProvince = async (unitId: string, provinceUnit: IprovinceUnit[]) => {
  const path = "provinceUnit/addProvinceUnit"
  const params = {
    unitId, provinceUnit
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  )
  return result
}

export const editIProvince = async (id: number, unitId: number, provinceUnit: IprovinceUnit[]) => {
  const path = "provinceUnit/editProvinceUnit"
  const params = {
    id, unitId, provinceUnit
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}

export const deleteIProvince = async (id: number) => {
  const path = "provinceUnit/deleteProvinceUnit"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  )
  return result
}
export const updateStatusIProvince = async (id: number) => {
  const path = "provinceUnit/activeProvinceUnit"

  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}
